import { render, staticRenderFns } from "./BaseDialogDelete.vue?vue&type=template&id=06727cd8"
import script from "./BaseDialogDelete.vue?vue&type=script&lang=js"
export * from "./BaseDialogDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports